export default function ContractsPage() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Forward Contracts</h1>
      <p className="text-muted-foreground">Contract management interface will be displayed here.</p>
    </div>
  );
}
